import React, { FC, useState } from 'react';

import API from '../../tools/API';
import style from './Modal.module.scss';

interface Props {
    id: number,
    openModal: (arg: number | boolean) => void
}

const RemovePoll: FC<Props> = ({ id, openModal }) => {
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const removePoll = (id: number) => {
        API.removePoll(id)
            .then(() => {
                openModal(false);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                setError(err.response.data.Exception);
            })
    }

    return (
        <>
            <form>
                <div className={style.addPoll__row}>
                    <p>Czy na pewno chcesz usunąć to głosowanie?</p>
                </div>
                <div className={style.addPoll__row}>
                    {!loading ? <>
                        <input
                            type="button"
                            value="USUŃ"
                            className={style.AddCathegory__button}
                            onClick={(e) => {
                                e.preventDefault();
                                setLoading(true);
                                removePoll(id);
                            }}
                        />
                        <input
                            type="button"
                            value="ANULUJ"
                            className={style.AddCathegory__button}
                            onClick={(e) => {
                                e.preventDefault();
                                openModal(false);
                            }}
                        />
                    </> : <p className={style.loader}>Trwa usuwanie...</p>
                    }
                    {error &&
                        <div className={style.addPoll__row}>
                            <p className={style.errorText}>{error}</p>
                        </div>
                    }
                </div>
            </form>
        </>
    )
}

export default RemovePoll